function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class ActiveUsersAndTeams {
    get getActiveUsersAndTeams() {
        return this._activeUsersAndTeams;
    }
    set setActiveUsersAndTeams(value) {
        this._activeUsersAndTeams = value;
    }
    constructor(){
        _define_property(this, "_activeUsersAndTeams", {
            teams: [],
            users: []
        });
    }
}
